'use strict';

import angular from 'angular';
import {UtilService} from './util.service';
import {EnterEventDirective} from './enter-event';
import {CapitalizeDirective} from './text-uppercase';
import ToasterService from './toaster.service';

export default angular.module('pizzutoAutopartesApp.util', [])
    .factory('Util', UtilService)
    .factory('ToasterService', ToasterService)
    .directive('enterEvent', EnterEventDirective)
    .directive('capitalize', CapitalizeDirective)
    .name;



// WEBPACK FOOTER //
// ./client/components/util/util.module.js